import { useEffect, useState } from 'react'
import { useLocation, Navigate } from 'react-router'
import { SpinnerLoader } from 'shared/ui'
import { CHATBOT_NAME_LIMIT } from 'shared/constants/limits'
import { ChatbotInstructionType } from 'entities/Chatbot'
import { UnifiedAgentContent } from 'pages/chatbot/ui/UnifiedAgent'
import { useUnifiedAgentContext } from 'pages/chatbot/ui/UnifiedAgent/context/unifiedAgentContext'
import { AgentEditPreloadStore } from 'pages/chatbot/store/agentEditPreloadStore'
import { ChatbotPath } from 'pages/chatbot/route/chatbotPath'
import { ChatbotNewPage } from './ChatbotNewPage'

export const ChatbotNewV2Page = () => {
  const { chatStore, loadFromData, model, nameInputStore } = useUnifiedAgentContext()
  const { state } = useLocation()
  const [preloadStore] = useState(() => new AgentEditPreloadStore())
  const [isLoading, setIsLoading] = useState(true)
  const [isNotUnified, setIsNotUnified] = useState(false)

  useEffect(() => {
    if (state?.initialInstruction) {
      chatStore.initWithPrompt(state.initialInstruction)
    }
  }, [])

  useEffect(() => {
    const load = async () => {
      if (state?.duplicateId) {
        await preloadStore.load(Number(state.duplicateId))
        const data = preloadStore.data

        if (data && data.type !== ChatbotInstructionType.Unified) {
          setIsNotUnified(true)
          setIsLoading(false)
          return
        }

        if (data) {
          loadFromData({ ...data, creator_session_id: undefined })

          model.syncOrigin({
            ...data,
            status: null,
            is_active: false,
          })
          nameInputStore.setName(`Copy of ${data.name}`.slice(0, CHATBOT_NAME_LIMIT))
        }
      }
      setIsLoading(false)
    }
    load()
  }, [state?.duplicateId])

  if (isLoading) return <SpinnerLoader ariaLabel='AgentCreateRouter' />
  if (state?.duplicateId && (!preloadStore.data || preloadStore.error))
    return <Navigate to={ChatbotPath.texting} replace />
  if (isNotUnified) return <ChatbotNewPage />

  return <UnifiedAgentContent />
}
